import axios from 'axios'
import pubsub from 'pubsub-js'
import React from 'react'
import { withRouter } from 'react-router'
import { Button, Card, CardBody, CardHeader, CardTitle, Col, Collapse, Row, Table } from 'reactstrap'
import Swal from 'sweetalert2'
import 'sweetalert2/src/sweetalert2.scss'
import ContentWrapper from '../../../components/Layout/ContentWrapper'

class ProcessMonthlyTargetHours extends React.Component {
  constructor() {
    super()
    this.state = {
      isLoading: false,
      matched: [],
      notMatched: [],
      importMonth: '',
      importYear: '',
      accordionState: [true, true, true], // Matched section (index 2) is now open by default
      fileData: null
    }
  }

  processData = (data) => {
    var importMonth = data.import_month
    var importYear = data.import_year

    var matched = data.data.filter((elem) => elem.userdata != null && elem.isInCSV == true)
    var notMatched = data.data.filter((elem) => elem.userdata == null && elem.isInCSV == true)
    
    this.setState({
      matched,
      notMatched,
      importMonth,
      importYear,
      fileData: data.fileData
    })
  }

  async componentDidMount() {
    if (this.props.location.state && this.props.location.state.importData) {
      this.processData(this.props.location.state.importData)
    } else {
      this.props.history.push('/users')
    }
  }

  toggleAccordion = (id) => {
    let accordionState = this.state.accordionState.map((val, i) => {
      return id === i ? !val : this.state.oneAtATime ? false : val
    })
    this.setState({
      accordionState
    })
  }

  _processData = () => {
    Swal.fire({
      title: 'A jeni i sigurt?',
      text: `Të dhënat do të importohen për muajin e zgjedhur.`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Po, vazhdo.',
      cancelButtonText: 'Jo.'
    }).then((result) => {
      if (result.value) {
        this.setState({ isLoading: true })
        
        const formData = new FormData()
        formData.append('file', this.state.fileData)
        formData.append('target_month', this.state.importMonth)
        formData.append('target_year', this.state.importYear)

        Swal.fire({
          title: 'Ju lutem prisni...',
          html: 'Duke ngarkuar të dhënat!',
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading()
          }
        })

        axios.post('monthlyTargetHours', formData)
          .then((importResult) => {
            Swal.close()
            if (importResult.data.success) {
              pubsub.publish('showNotification', {
                message: 'Të dhënat u ngarkuan me sukses!',
                type: 'success'
              })
              pubsub.publish('monthlyTargetHoursImportSuccess')
              this.props.history.push('/users')
            } else {
              pubsub.publish('showNotification', {
                message: importResult.data.message || 'Gabim gjatë importimit të të dhënave',
                type: 'error'
              })
              this.setState({ isLoading: false })
            }
          })
          .catch((error) => {
            Swal.close()
            const message =
              error.response?.data?.message || 'Gabim gjatë procesimit të fajllit'
            pubsub.publish('showNotification', {
              message,
              type: 'error'
            })
            this.setState({ isLoading: false })
          })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        pubsub.publish('showNotification', {
          message: 'Procesimi u anulua',
          type: 'error'
        })
      }
    })
  }

  render() {
    return (
      <ContentWrapper>
        <div className='content-heading d-flex justify-content-between'>
          <p>
            Verifiko Monthly Target Hours: Muaji {this.state.importMonth}, Viti {this.state.importYear}
          </p>
          <div>
            <Button onClick={() => this.props.history.goBack()} color='info' className='btn-labeled'>
              <span className='btn-label'>
                <i className='fa fa-arrow-left' />
              </span>{' '}
              Prapa
            </Button>
          </div>
        </div>

        <Row>
          <Col lg={12} className={this.state.isLoading ? 'whirl standard' : ''}>
            {this.state.notMatched.length > 0 && (
              <Card outline color='danger' className='mb-3'>
                <CardHeader onClick={() => this.toggleAccordion(0)} className='text-white bg-danger cursor-pointer'>
                  <em className={`fa-fw fas icon-arrow-${this.state.accordionState[0] ? 'up' : 'down'} mr-2`}></em>
                  Të dhënat mungojnë
                </CardHeader>
                <Collapse isOpen={this.state.accordionState[0]}>
                  <CardBody>
                    <CardTitle>Për përdoruesit e mëposhtëm mungojnë të dhënat në sistem</CardTitle>
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th>Emri</th>
                          <th>User ID</th>
                          <th>Partner ID</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.notMatched.map((elem, index) => {
                          return (
                            <tr key={index}>
                              <td>{elem.name}</td>
                              <td>{elem.user_id || '-'}</td>
                              <td>{elem.partner_id || '-'}</td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </Table>
                  </CardBody>
                </Collapse>
              </Card>
            )}
            {this.state.matched.length > 0 && (
              <Card outline color='success' className='mb-3'>
                <CardHeader onClick={() => this.toggleAccordion(2)} className='text-white bg-success cursor-pointer'>
                  {' '}
                  <em className={`fa-fw fas icon-arrow-${this.state.accordionState[2] ? 'up' : 'down'} mr-2`}></em>
                  Të dhënat e përputhura
                </CardHeader>
                <Collapse isOpen={this.state.accordionState[2]}>
                  <CardBody>
                    <CardTitle>Të dhënat më poshtë janë përputhur. Ju lutem rishikojini edhe një herë</CardTitle>
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th>Emri Mbiemri</th>
                          <th>User ID</th>
                          <th>Partner ID</th>
                          <th>ID Card</th>
                          <th>Transferet</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.matched.map((elem, index) => {
                          const hasTransfers = elem.hasTransfers && elem.transfers && elem.transfers.length > 0;
                          const rowStyle = hasTransfers ? { backgroundColor: '#fff3cd' } : {}; // Light yellow background for users with transfers
                          
                          return (
                            <tr key={index} style={rowStyle}>
                              <td>
                                <div className='media'>
                                  <img
                                    className='align-self-center mr-2 rounded-circle img-thumbnail thumb48'
                                    src={'/img/blank_profile.png'}
                                    alt={`${elem.userdata.first_name} ${elem.userdata.last_name}`}
                                  />
                                  <div className='media-body py-2'>
                                    <div className='text-bold'>
                                      {`${elem.userdata.first_name} ${elem.userdata.last_name}`}
                                      {hasTransfers && (
                                        <span className='badge badge-warning ml-2' title='Ky përdorues ka transferime'>
                                          <i className='fa fa-exchange-alt'></i> Transfer
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td>{elem.user_id || '-'}</td>
                              <td>{elem.partner_id || '-'}</td>
                              <td>{elem.userdata.identity_card || '-'}</td>
                              <td>
                                {hasTransfers ? (
                                  <div>
                                    {elem.transfers.map((transfer, transferIndex) => {
                                      const transferDate = transfer.start_date
                                        ? new Date(transfer.start_date).toLocaleDateString('sq-AL', {
                                            year: 'numeric',
                                            month: '2-digit',
                                            day: '2-digit'
                                          })
                                        : 'N/A';
                                      return (
                                        <div key={transferIndex} className='mb-1'>
                                          <small className='text-muted'>
                                            <strong>Nga:</strong> {transfer.from_department} → <strong>Tek:</strong> {transfer.to_department}
                                            <br />
                                            <strong>Data:</strong> {transferDate}
                                          </small>
                                        </div>
                                      );
                                    })}
                                  </div>
                                ) : (
                                  <span className='text-muted'>-</span>
                                )}
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </Table>
                  </CardBody>
                </Collapse>
              </Card>
            )}
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <div className='form-group row float-right'>
              <div className='col-md-10'>
                <button className='btn btn-info' onClick={this._processData}>
                  Proceso
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </ContentWrapper>
    )
  }
}

export default withRouter(ProcessMonthlyTargetHours)
